import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { withTheme } from 'styled-components'

import moment from 'moment'
import _ from 'lodash'
import { saveAs } from 'file-saver'
import { Flex, FlexColumn } from '../Reusable/Container'
import { Button, TextButton, Chip, ImageButton } from '../Reusable/Button'
import { Image } from '../Reusable/Image'
import { apiPOSTReq } from '../../Utils/api'
import environment from '../../environment'
import { ErrorAlert } from '../Reusable/Alert'
import { Dropdown, Menu } from '../Reusable/Dropdown'
import { LabeledInput } from '../Reusable/Input'
import { Text } from '../Reusable/Text'
import { LoadingOutlined } from '@ant-design/icons'
import FilterIcon from '../../Images/filter.png'
import Download from "../../Images/download.png"

var dFormat = "YYYY-MM-DD"

class SearchAndFilter extends Component {

    state = {
        loading: true,
        selectedTab: "Aion",
        pagination: {
            current: 1,
            pageSize: this.props.pageSize,
            showSizeChanger: false,
        },
        sorter: {},
        sortDirection: "DESC",
        showClear: false,
        selectedRowsPageDict: {},
        selectedRowKeyPageDict: {},
    }

    componentDidMount() {
    }

    showClearAll = () => {
        const { clearAll } = this.props
        var { filterFromDate, filterToDate } = this.state
        if (filterFromDate || filterToDate) {
            this.setState({ clearAll: true }, () => {
                clearAll();
            })
        }
        else if (!filterFromDate && !filterToDate) {
            this.setState({ clearAll: false }, () => {
                clearAll();
            })
        }
    }

    clearAll = () => {
        const { clearAll, pageSize } = this.props

        this.setState({
            fromDate: null,
            toDate: null,
            filterFromDate: null,
            filterToDate: null,
            clearAll: null,
            pagination: {
                current: 1,
                pageSize: pageSize,
            },
        }, () => {
            clearAll();
        })
    }

    downloadCSVStmt(options) {
        var { filterFromDate, filterToDate } = options

        let fetchOptions = {
            sortFieldDirection: 'DESC',
            fromDate: filterFromDate,
            toDate: filterToDate,
            download: true,
        }

        this.setState({ csvDownloading: true })

        apiPOSTReq(`${environment.lsmBaseUrl}/lsm/getDailyReport`, {}, fetchOptions, (err, resp) => {
            this.setState({ csvDownloading: false });
            try {
                const data = resp || {};
                if (data) {
                    const blob = new Blob([data.dailyReportCsv], {
                        type: 'application/vnd.ms-excel',
                    });
                    const fileURL = URL.createObjectURL(blob);
                    saveAs(fileURL, filterFromDate ? `Daily Report ${filterFromDate} to ${filterToDate}.csv` : `Daily Report.csv`);
                } else {
                    throw Error(data.responseMessage || data.error)
                }
            } catch (error) {
                console.log("/counterparty err", error, resp);
                ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again." });
            }
        });
    }

    render() {
        const { filterFromDate, filterToDate, clearAll, csvDownloading, fromDate, toDate, dropdownVisible } = this.state
        const { fetchData, pageSize } = this.props
        return (
            <Flex between centerHorizontally gap='12px'>
                <Flex end fullWidth style={{}}>
                    {
                        (filterFromDate && filterToDate) &&
                        <Flex between fullWidth centerHorizontally>
                            <Flex start wrap gap='8px' centerHorizontally>
                                {
                                    <Chip closable onDelete={() => {
                                        this.setState({
                                            fromDate: null, toDate: null, filterFromDate: null, filterToDate: null,
                                            pagination: { current: 1, pageSize: pageSize }
                                        }, () => this.showClearAll())
                                    }} text={`Date: ${moment(filterFromDate).format('ll')} - ${moment(filterToDate).format('ll')}`} />
                                }
                            </Flex>
                        </Flex>
                    }
                </Flex>
                <Flex gap='12px' centerHorizontally>
                    {
                        clearAll &&
                        <>
                            <Text primary noWrap underline style={{ cursor: 'pointer' }} onClick={() => this.clearAll()}>Clear all</Text>
                        </>
                    }

                    <Flex gap="8px" center>
                        <ImageButton src={Download} onClick={() => this.downloadCSVStmt({ ...this.state })} />
                        {csvDownloading && <LoadingOutlined style={{ fontSize: 18 }} spin />}
                    </Flex>
                    <Dropdown
                        placement='bottomRight'
                        trigger='click'
                        onVisibleChange={flag => this.setState({ dropdownVisible: flag })}
                        visible={dropdownVisible}
                        overlay={(
                            <Menu onClick={() => { }} style={{ width: 600, padding: '12px 24px 24px', borderRadius: 8 }}>
                                <FlexColumn left gap='24px'>
                                    <Flex between gap='24px'>
                                        <LabeledInput
                                            label="From"
                                            type="date-picker"
                                            disabledDate={(date) => date > moment().endOf('day') ? true : (toDate != null ? date > this.state.toDate : false)}
                                            placeholder='MM/DD/YYYY'
                                            value={fromDate}
                                            format={'MM/DD/YYYY'}
                                            onChange={(fromDate, dateStr) => this.setState({ fromDate: fromDate })}
                                        />
                                        <LabeledInput
                                            label="To"
                                            type="date-picker"
                                            disabledDate={(date) => date > moment().endOf('day') ? true : (fromDate != null ? date < this.state.fromDate : false)}
                                            placeholder='MM/DD/YYYY'
                                            value={toDate}
                                            format={'MM/DD/YYYY'}
                                            onChange={(toDate, dateStr) => this.setState({ toDate: toDate })}
                                        />
                                    </Flex>
                                    <Button solid disabled={!fromDate || !toDate} text='APPLY' onClick={() => {
                                        this.setState({ filterFromDate: fromDate.format(dFormat), filterToDate: toDate.format(dFormat) }, () => {
                                            var updatedState = {
                                                dateType: "Custom",
                                                loading: true,
                                                fromDate: fromDate.format(dFormat),
                                                toDate: toDate.format(dFormat),
                                                pagination: {
                                                    current: 1,
                                                    pageSize: pageSize,
                                                },
                                                fromApply: true,
                                            }
                                            this.setState({ dropdownVisible: false, clearAll: true, amountError: false, })
                                            fetchData({ ...this.state, ...updatedState })
                                        })
                                    }} />
                                </FlexColumn>
                            </Menu>
                        )}
                    >
                        <TextButton text='FILTER' rightIcon={<Image src={FilterIcon} />} />
                    </Dropdown>
                </Flex>
            </Flex>
        )
    }
}
function mapStateToProps(state) {
    return {
        aionStore: state.aionAppReducer
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(SearchAndFilter)))